define("vm-reviewunconfirmedendpoints", [], function () {
    function ReviewUnconfirmedEndpoints() {

        var self = this;

        // Private Variables
        var placeholder = "review-unconfirmed-messages";
        var endpointListFilter = { searchValue: "", page: 1, maxItems: 20 };
        var computerIcons = cccApp.enums.computerIcons;

        // Observables
        self.endpointNameFilter = ko.observable("");
        self.selectedGroup = ko.observable(0);
        self.isLoadMoreEnabled = ko.observable(false);
        self.isLoading = ko.observable(false);
        self.isConfirming = ko.observable(false);
        self.isRejecting = ko.observable(false);

        self.chosenEndpoints = ko.observableArray();
        self.unconfirmedEndpoints = ko.observableArray();
        self.groups = ko.observableArray();
        self.failedEndpoints = ko.observableArray();

        // Computeds
        self.isMobileViewport = ko.computed(function () {
            var size = cccApp.clientSystem && cccApp.clientSystem.window && cccApp.clientSystem.window.bootstrapSize() ? cccApp.clientSystem.window.bootstrapSize() : "";
            return (size === cccApp.enums.boostrapSizes.xs.name || size === cccApp.enums.boostrapSizes.sm.name);
        });

        self.isIE9 = ko.computed(function () {
            return cccApp.clientSystem && cccApp.clientSystem.browser === "Internet Explorer" && cccApp.clientSystem.browserMajorVersion === 9;
        });

        self.isActionInProgress = ko.computed(function() {
            return self.isLoading() || self.isConfirming() || self.isRejecting();
        });

        self.isConfirmEnabled = ko.computed(function () {
            return !self.isActionInProgress() && self.chosenEndpoints().length > 0 && self.selectedGroup() > 0;
        });

        self.isRejectEnabled = ko.computed(function() {
            return !self.isActionInProgress() && self.chosenEndpoints().length > 0;
        });

        self.selectAllText = ko.pureComputed(function () {
            return self.chosenEndpoints().length - self.chosenEndpointsHidden().length < self.unconfirmedEndpoints().length ? "Select all" : "Deselect all";
        });

        self.chosenEndpointsHidden = ko.computed(function () {
            var hiddenEndpoints = ko.utils.arrayFilter(self.chosenEndpoints(),
                function (chosenItem) {
                    var found = chosenItem.isConfirmed();
                    if (!found) {
                        var i = self.unconfirmedEndpoints().length - 1;
                        for (; i >= 0; i--) {
                            found = self.unconfirmedEndpoints()[i].guid() === chosenItem.guid();
                            if (found) {
                                break;
                            }
                        }

                        if (!found && self.endpointNameFilter.searchValue === "") {
                            self.chosenEndpoints().remove(chosenItem);
                            found = true;
                        }
                    }

                    return !found;
                });

            return hiddenEndpoints;
        });

        self.groupSeparatorText = ko.computed(function () {

            if (self.groups && typeof self.groups === "function") {
                var length = 0;
                for (var i = 0; i < self.groups().length; i++) {
                    if (self.groups()[i].groupName().length > length) {
                        length = self.groups()[i].groupName().length;
                    }
                }
                return Array(length).join("─");

            } else {
                return "";
            }
        });

        self.groupNames = ko.computed(function () {
            var names = [];
            
            if (!self.isMobileViewport()) {
                names.push({ groupId: null, groupName: self.groupSeparatorText(), disabled: true });
            }

            ko.utils.arrayForEach(self.groups(), function (group) {
                names.push(group);

                if (group.defaultGroup() && !self.isMobileViewport()) {
                    names.push({ groupId: null, groupName: self.groupSeparatorText(), disabled: true });
                }
            });

            return names;
        });

        // Subscribes
        self.chosenEndpointsHidden.subscribe(function (value) {
            var cbSelectAll = $("#cb-review-unconfirmed-select-all");
            if (self.chosenEndpoints().length - value.length > 0) {
                cbSelectAll.prop("indeterminate", (self.chosenEndpoints().length - value.length) < self.unconfirmedEndpoints().length);
                cbSelectAll.prop("checked", (self.chosenEndpoints().length - value.length) === self.unconfirmedEndpoints().length);
            } else {
                cbSelectAll.prop("indeterminate", false);
                cbSelectAll.prop("checked", false);
            }
        });

        // Event Handlers
        self.filterListClick = function() {
            endpointListFilter.searchValue = self.endpointNameFilter();
            endpointListFilter.page = 1;
            postLoadUnconfirmedEndpoints();
        };

        self.clearEndpointSearch = function() {
            self.endpointNameFilter("");
            self.filterListClick();
        };

        self.selectAllClick = function() {
            self.failedEndpoints([]);
            if (self.chosenEndpoints().length - self.chosenEndpointsHidden().length < self.unconfirmedEndpoints().length) {
                ko.utils.arrayForEach(self.unconfirmedEndpoints(),
                    function(item) {
                        var foundItem = ko.utils.arrayFirst(self.chosenEndpoints(), function(chosenItem) {
                            return chosenItem.guid() === item.guid();
                        });
                        if (!foundItem) {
                            self.chosenEndpoints().push(item);
                        }
                    });
            } else {

                // If there's been no filtering done to the endpoints
                if (self.endpointNameFilter() === "") {
                    self.chosenEndpoints.removeAll();
                }
                // Else, only deselect the selected unconfirmed endpoints
                else {
                    ko.utils.arrayForEach(self.unconfirmedEndpoints(),
                        function(item) {
                            var foundItem = ko.utils.arrayFirst(self.chosenEndpoints(), function(chosenItem) {
                                return chosenItem.guid() === item.guid();
                            });

                            if (foundItem) {
                                self.chosenEndpoints.remove(foundItem);
                            }
                        });
                }
            }

            setTimeout(function() { self.chosenEndpoints.valueHasMutated(); }, 0);
            return false;
        };

        self.confirmEndpointsClick = function() {
            postConfirmEndpoints();
        };

        self.rejectEndpointsClick = function() {
            postRejectEndpoints();
        };

        self.loadMoreClick = function() {
            if (!self.isLoading()) {
                postLoadUnconfirmedEndpoints(true);
            }
        };

        self.removeEndpointClick = function(endpoint) {
            if (endpoint && !self.isConfirming() && !self.isRejecting()) {
                self.chosenEndpoints.remove(function (item) { return item.guid() === endpoint.guid(); });
            }
        };

        // Public Functions
        self.init = function() {
        };

        self.render = function() {
            self.reset();
            postLoadUnconfirmedEndpoints();
        };

        self.reset = function() {
            self.unconfirmedEndpoints([]);
            self.chosenEndpoints([]);
            self.groups([]);
            self.endpointNameFilter("");
            self.isLoading(false);
            self.isConfirming(false);
            self.isRejecting(false);
            endpointListFilter.searchValue = self.endpointNameFilter();
            endpointListFilter.page = 1;
        };

        self.close = function() {
            cccApp.closePopup();
        };

        self.smallIcon = function(endpoint) {
            var icon;
            if (typeof endpoint === "object" && endpoint) {
                icon = JSON.parse(JSON.stringify(computerIcons[endpoint.iconId()]));
                icon.cssClass = icon.cssClass + " comp-ic-sm";
            } else {
                icon = JSON.parse(JSON.stringify(computerIcons[0]));
                icon.cssClass = icon.cssClass + " comp-ic-sm";
            }

            return icon;
        };

        self.isOptionDisabled = function(option, item) {
            if (option && item && item.disabled) {
                ko.applyBindingsToNode(option, { disable: true }, item);
            }
        };

        self.isSelected = function(endpoint) {
            if (endpoint) {
                return ko.computed({
                    read: function() {
                        return ko.utils.arrayFirst(self.chosenEndpoints(), function(chosenItem) {
                            return chosenItem.guid() === endpoint.guid();
                        });
                    },
                    write: function(value) {
                        var item = ko.utils.arrayFirst(self.chosenEndpoints(),
                            function(chosenItem) {
                                return chosenItem.guid() === endpoint.guid();
                            });
                        if (value) {
                            if (!item) {
                                self.chosenEndpoints.push(endpoint);
                            }
                        } else {
                            if (item) {
                                var index = ko.utils.arrayIndexOf(self.chosenEndpoints(), item);
                                if (index > -1) {
                                    self.chosenEndpoints.splice(index, 1);
                                }
                            }
                        }
                    }
                });
            } else {
                return false;
            }
        };

        self.isFailedState = function(endpoint) {
            if (endpoint) {
                return ko.computed(function() {
                    return ko.utils.arrayFirst(self.failedEndpoints(), function(idValue) {
                        return idValue === endpoint.guid();
                    });
                });
            } else {
                return false;
            }
        };

        // Private Methods
        function removeSuccessfulEndpointsFromArrays(endpointList) {
            if (typeof endpointList === "undefined" || !endpointList || endpointList.length === 0) {
                return;
            }

            for (var i = 0; i < endpointList.length; i++) {
                self.unconfirmedEndpoints().splice(ko.utils.arrayIndexOf(self.unconfirmedEndpoints(), endpointList[i]), 1);

                var chosenItem = ko.utils.arrayFirst(self.chosenEndpoints(),
                    function (item) {
                        return item.guid() === endpointList[i].guid();
                    });

                if (chosenItem) {
                    self.chosenEndpoints().splice(ko.utils.arrayIndexOf(self.chosenEndpoints(), chosenItem), 1);
                    $("#endpoint-confirm-" + chosenItem.guid()).addClass("collapsing");
                }
            }

            if (self.unconfirmedEndpoints().length - endpointList.length < endpointListFilter.maxItems) {
                endpointListFilter.page = 1;
                postLoadUnconfirmedEndpoints();
            }

            setTimeout(function() {
                    self.chosenEndpoints.valueHasMutated();
                    self.unconfirmedEndpoints.valueHasMutated();
                },
                500);
        }

        function postLoadUnconfirmedEndpoints(addItems) {
            if (!self.isLoading()) {
                self.isLoading(true);
                if (addItems) {
                    endpointListFilter.page++;
                }

                var postData = ko.toJSON(endpointListFilter);
                cccApp.msg.clear(placeholder);
                cccApp.api.post({
                    url: "network/hosts/listunconfirmed",
                    data: postData,
                    messagePlaceholder: placeholder,
                    success: function(result) {
                        if (result.data) {
                            self.isLoadMoreEnabled(!!result.data.hasMoreResults);
                            if (addItems) {
                                self.unconfirmedEndpoints.push
                                    .apply(self.unconfirmedEndpoints, ko.mapping.fromJS(result.data.endpoints, {})());
                            } else {
                                ko.mapping.fromJS(result.data.endpoints, {}, self.unconfirmedEndpoints);
                            }

                            ko.mapping.fromJS(result.data.groups, {}, self.groups);
                        }
                    },
                    error: function() {
                        if (addItems && endpointListFilter.page > 1) {
                            endpointListFilter.page--;
                        }
                    },
                    complete: function() {
                        self.isLoading(false);
                    }
                });
            }
        }

        function postConfirmEndpoints() {
            if (!self.isActionInProgress()) {
                self.isConfirming(true);
                self.failedEndpoints([]);
                var idList = $.map(self.chosenEndpoints(), function(item) {
                    return item.guid();
                });

                var postData = ko.toJSON({ groupid: self.selectedGroup, endpointids: idList });

                cccApp.api.post({
                    url: "network/hosts/approveMultiplePairedEndpoints",
                    data: postData,
                    messagePlaceholder: placeholder,
                    success: function(result) {
                        if (result.data) {
                            var wereAnySuccessful = false;
                            var endpoint;
                            var i = 0;
                            if (result.data.confirmedEndpoints && result.data.confirmedEndpoints.length > 0) {
                                var confirmedList = [];
                                wereAnySuccessful = true;
                                for (i = 0; i < result.data.confirmedEndpoints.length; i++) {
                                    endpoint = ko.utils.arrayFirst(self.unconfirmedEndpoints(),
                                        function(item) {
                                            return item.guid() === (result.data.confirmedEndpoints[i] + "");
                                        });

                                    if (endpoint) {
                                        endpoint.isConfirmed(true);
                                        confirmedList.push(endpoint);
                                    }
                                }

                                if (!result.data.failedEndpoints || result.data.failedEndpoints.length === 0) {
                                    cccApp.msg.success("Your endpoints were succesfully confirmed", placeholder);
                                }

                                cccApp.account.refreshUnconfirmedEndpointCount();
                                setTimeout(function () {
                                    removeSuccessfulEndpointsFromArrays(confirmedList);
                                    cccApp.msg.clear(placeholder);
                                }, 3000);
                            }

                            if (result.data.failedEndpoints && result.data.failedEndpoints.length > 0) {
                                if (wereAnySuccessful) {
                                    cccApp.msg.warning("Some of your endpoints could not be confirmed", placeholder, true);
                                } else {
                                    cccApp.msg.error("Your endpoints could not be confirmed", placeholder, true);
                                }

                                for (i = 0; i < result.data.failedEndpoints.length; i++) {
                                    self.failedEndpoints().push(result.data.failedEndpoints + "");
                                }

                                self.failedEndpoints.valueHasMutated();
                            }
                        } else {
                            cccApp.msg.error("Sorry, there was a problem confirming the endpoints you selected", placeholder, true);
                        }
                    },
                    complete: function() {
                        self.isConfirming(false);
                    }
                });
            }
        }

        function postRejectEndpoints() {
            if (!self.isActionInProgress()) {
                self.isRejecting(true);
                self.failedEndpoints([]);
                var idList = $.map(self.chosenEndpoints(), function (item) {
                    return item.guid();
                });

                var postData = ko.toJSON({ endpointids: idList });

                cccApp.api.delete({
                    url: "network/hosts/rejectMultiplePairedEndpoints",
                    data: postData,
                    messagePlaceholder: placeholder,
                    success: function (result) {
                        if (result.data) {
                            var wereAnySuccessful = false;
                            var endpoint;
                            var i = 0;
                            if (result.data.rejectedEndpoints && result.data.rejectedEndpoints.length > 0) {
                                var rejected = [];
                                wereAnySuccessful = true;
                                for (i = 0; i < result.data.rejectedEndpoints.length; i++) {
                                    endpoint = ko.utils.arrayFirst(self.unconfirmedEndpoints(),
                                        function (item) {
                                            return item.guid() === (result.data.rejectedEndpoints[i] + "");
                                        });

                                    if (endpoint) {
                                        endpoint.isActive(false);
                                        rejected.push(endpoint);
                                    }
                                }

                                if (!result.data.failedEndpoints || result.data.failedEndpoints.length === 0) {
                                    cccApp.msg.success("Your endpoints were rejected", placeholder);
                                }

                                cccApp.account.refreshUnconfirmedEndpointCount();
                                setTimeout(function () {
                                    removeSuccessfulEndpointsFromArrays(rejected);
                                    cccApp.msg.clear(placeholder);
                                }, 3000);
                            }

                            if (result.data.failedEndpoints && result.data.failedEndpoints.length > 0) {
                                if (wereAnySuccessful) {
                                    cccApp.msg.warning("Some of your endpoints could not be rejected", placeholder, true);
                                } else {
                                    cccApp.msg.error("Your endpoints could not be rejected", placeholder, true);
                                }

                                for (i = 0; i < result.data.failedEndpoints.length; i++) {
                                    self.failedEndpoints().push(result.data.failedEndpoints + "");
                                }

                                self.failedEndpoints.valueHasMutated();
                            }
                        } else {
                            cccApp.msg.error("Sorry, there was a problem rejecting the endpoints you selected", placeholder, true);
                        }
                    },
                    complete: function () {
                        self.isRejecting(false);
                    }
                });
            }
        }
    }

    return ReviewUnconfirmedEndpoints;
});